import React, { useEffect, useState } from "react";
import styles from "./SeriesBanner.module.css";

import { SeriesWorkBook } from "../BookTypes/WorkTypes/SeriesWorkBook";
import { useMediaUpdate } from "../../contexts/MediaContext"
import { getMediasInSeries, verifyToken } from "../../api/Api";

export const SeriesBanner = (props) => {
    
    // props:
    //
    // seriesItem - object containing series id and name

    // ----------------------------------------------------- STATE AND HOOKS
    let token = localStorage.getItem("token");

    const [isLoaded, setIsLoaded] = useState(false);
    const [mediasInSeries, setMediasInSeries] = useState(null);
    const mediaUpdater = useMediaUpdate();

    useEffect(() => { // prevents loading before data has arrived
        console.log(props.seriesItem?.seriesid === undefined)


        if (mediasInSeries !== null) {
            console.log("true is loaded")
            setIsLoaded(true);
        } else if (Object.keys(props.seriesItem).length !== 0) {
            console.log("false fetching")
            fetch_works_in_series();
        }
    }, [props.seriesItem])

    useEffect(() => { // clears book to prevent flash of pervious one
        mediaUpdater({});
    }, [])

    // ----------------------------------------------------- PRE-RENDER

    async function fetch_works_in_series() {
        // fetches media items from back

        await getMediasInSeries(props.seriesItem.seriesid, token)
            .then((mediaList) => {
                // sorts by series number
                let sortedMediaItems = mediaList.sort(function (a, b) {
                    if (a.seriesnum > b.seriesnum) {
                        return 1;
                    }
                    if (a.seriesnum < b.seriesnum) {
                        return -1;
                    }
                    return 0;
                });

                console.log(sortedMediaItems)
                // saves
                setMediasInSeries(sortedMediaItems);
            })
            .catch((error) => {
                console.log("Failed to get medias in series", error);
            })
    }

    // ----------------------------------------------------- RENDER

    if (!isLoaded) {
        return (
            <div></div>
        )
    } else {
        return (
            <div className={styles.container}>
                <div className={styles.content}>
                    <h1 className={styles.seriesName}>{props.seriesItem.name}</h1>
                    <div className={styles.workContainer}>{mediasInSeries.map((media) => <div key={media.seriesnum}><SeriesWorkBook mediaItem={media} /></div>)}</div>
                </div>
            </div>
        );
    }
}